<div style="flex: 1; display: flex; flex-direction: column; overflow-y: hidden; max-height: 100%; width: 100%; background-color: var(--tdo-background);" data-cy="scheduler-day-detail-container">
  <div style="flex-basis: 80px; display: flex;" data-cy="scheduler-day-summary-section">
    <div style="flex: 1; background-color: white; border-radius: var(--border-radius); padding: 2px 8px 2px 8px;" data-cy="scheduler-today-summary">
      <div style="color: var(--tdo-secondary); font-size: 12px; font-weight: 500;" data-cy="scheduler-today-title">Today's</div>
      <div style="display: flex;">
        <div style="flex: 1; display: flex;" data-cy="scheduler-today-appointments-section">
          <div style="flex-basis: 40px; height: 40px;">
            <div style="width: 100%; height: 100%; background-color: var(--tdo-secondary); border-radius: 50%; color: white; padding: 4px; text-align: center;" data-cy="scheduler-today-appointments-icon">
              <mat-icon style="position: relative; top: 3px;">calendar_month</mat-icon>
            </div>
          </div>
          <div style="flex-basis: 6px;"></div>
          <div style="line-height: 0.9; padding-top: 1px;">
            <div style="color: var(--tdo-secondary);" data-cy="scheduler-today-appointments-label">Appointments</div>
            <div style="color: black; font-size: 30px; font-weight: 500;" data-cy="scheduler-today-appointments-value">{{detailData?.DailyAppointments}}</div>
          </div>
        </div>
        <div style="flex: 1; display: flex;" data-cy="scheduler-today-estimate-section">
          <div style="flex-basis: 40px; height: 40px;">
            <div style="width: 100%; height: 100%; background-color: var(--tdo-secondary); border-radius: 50%; color: white; padding: 4px; text-align: center;" data-cy="scheduler-today-estimate-icon">
              <mat-icon style="position: relative; top: 3px;">bar_chart</mat-icon>
            </div>
          </div>
          <div style="flex-basis: 6px;"></div>
          <div style="line-height: 0.9; padding-top: 1px;">
            <div style="color: var(--tdo-secondary);" data-cy="scheduler-today-estimate-label">Daily Estimate</div>
            <div style="color: black; font-size: 30px; font-weight: 500;" data-cy="scheduler-today-estimate-value">${{detailData?.DailyIntakeEstimate}}</div>
          </div>
        </div>
      </div>
    </div>
    <div style="flex-basis: 8px;"></div>
    <div style="flex: 2; background-color: white; border-radius: var(--border-radius); padding: 2px 8px 2px 8px;" data-cy="scheduler-weekly-summary">
      <mat-progress-bar *ngIf="isWeeklyLoading" mode="indeterminate" data-cy="scheduler-weekly-loading"></mat-progress-bar>
      <div style="color: var(--tdo-secondary); font-size: 12px; font-weight: 500;" data-cy="scheduler-weekly-title">Weekly</div>
      <div style="display: flex;">
        <div style="flex-basis: 240px; display: flex;" data-cy="scheduler-weekly-appointments-section">
          <div style="flex-basis: 40px; height: 40px;">
            <div style="width: 100%; height: 100%; background-color: var(--tdo-secondary); border-radius: 50%; color: white; padding: 4px; text-align: center;" data-cy="scheduler-weekly-appointments-icon">
              <mat-icon style="position: relative; top: 3px;">calendar_month</mat-icon>
            </div>
          </div>
          <div style="flex-basis: 6px;"></div>
          <div style="line-height: 0.9; padding-top: 1px;">
            <div style="color: var(--tdo-secondary);" data-cy="scheduler-weekly-appointments-label">Appointments</div>
            <div style="color: black; font-size: 30px; font-weight: 500;" data-cy="scheduler-weekly-appointments-value">{{weeklyData?.WeeklyAppointments}}</div>
          </div>
        </div>
        <div style="flex-basis: 240px; display: flex;" data-cy="scheduler-weekly-estimate-section">
          <div style="flex-basis: 40px; height: 40px;">
            <div style="width: 100%; height: 100%; background-color: var(--tdo-secondary); border-radius: 50%; color: white; padding: 4px; text-align: center;" data-cy="scheduler-weekly-estimate-icon">
              <mat-icon style="position: relative; top: 3px;">bar_chart</mat-icon>
            </div>
          </div>
          <div style="flex-basis: 6px;"></div>
          <div style="line-height: 0.9; padding-top: 1px;">
            <div style="color: var(--tdo-secondary);" data-cy="scheduler-weekly-estimate-label">Weekly Estimate</div>
            <div style="color: black; font-size: 30px; font-weight: 500;" data-cy="scheduler-weekly-estimate-value">${{weeklyData?.WeeklyIntakeEstimate}}</div>
          </div>
        </div>
        <div style="flex-basis: 6px;"></div>
        <div style="flex-basis: 240px; display: flex;" data-cy="scheduler-weekly-chart-section">
          <div style="flex-basis: 80px; height: 100%;">
            <dx-pie-chart style="height: 100%;"
              id="pie"
              palette="Aspect"
              [dataSource]="weeklyAreas"
              data-cy="scheduler-weekly-pie-chart"
            >
              <dxi-series argumentField="name" valueField="area">
                <!--<dxo-label [visible]="true">
                  <dxo-connector [visible]="true" [width]="1"></dxo-connector>
                </dxo-label>-->
              </dxi-series>
              <dxo-size [height]="80"></dxo-size>
              <!--<dxo-export [enabled]="true"></dxo-export>-->
            </dx-pie-chart>
          </div>
          <div style="flex-basis: 6px;"></div>
          <div style="line-height: 0.9; padding-top: 1px;">
            <div style="color: var(--tdo-secondary);" data-cy="scheduler-weekly-chart-label">WTD</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="flex-basis: var(--margin-size);"></div>
  <div style="flex: 1; background-color: white; border-radius: var(--border-radius); padding: 3px;" data-cy="scheduler-appointments-list-container">
    <app-tdo-accordion *ngIf="detailData && detailData.Appointments &&  detailData.Appointments.length > 0" data-cy="scheduler-appointments-accordion">
      <app-tdo-accordion-item #item *ngFor="let d of detailData.Appointments" data-cy="scheduler-appointment-item">
        <app-tdo-accordion-item-header style="width: 100%;" data-cy="scheduler-appointment-header">
          <div style="display: flex; width: 100%;">
            <div style="height: 30px; flex-basis: fit-content;" data-cy="scheduler-appointment-picture-container">
              <img *ngIf="!item.isExpanded" [src]="getPatientPicture(d)" style="position: relative; top: -4px; border-radius: var(--border-radius); max-width: 100%; max-height: 100%; margin-right: 10px;" data-cy="scheduler-appointment-patient-picture" />
            </div>
            <div style="flex-basis: 200px; min-width: 200px; margin-right: 10px; text-decoration: underline; cursor: pointer;" matTooltip="Goto Patient" (click)="changeToPatientAndGotoCaseView(d)" data-cy="scheduler-appointment-patient-name">{{d.PatientName}}</div>
            <div style="flex-basis: 80px; min-width: 80px; margin-right: 10px;" data-cy="scheduler-appointment-patient-contact">{{d.PatientContact}}</div>
            <div style="flex-basis: 80px; min-width: 80px; margin-right: 10px; margin-left: 10px;" data-cy="scheduler-appointment-patient-state">{{d.PatientState}}</div>
            <div style="flex-basis: 80px; min-width: 80px; margin-right: 10px;" data-cy="scheduler-appointment-date">{{d.AppointmentDate | date: 'shortDate'}}</div>
            <div style="flex-basis: 80px; min-width: 80px; margin-right: 10px;" data-cy="scheduler-appointment-time">{{d.AppointmentDate | date: 'shortTime'}}</div>
            <div style="flex: 1;"></div>
            <div style="flex-basis: 100px; display: flex;" data-cy="scheduler-appointment-actions">
              <div matTooltip="Patient Notes" style="cursor: pointer;" (click)="openPatientNotes(d)" data-cy="scheduler-appointment-notes-button"><mat-icon>description</mat-icon></div>
            </div>
          </div>
        </app-tdo-accordion-item-header>
        <app-tdo-accordion-item-content data-cy="scheduler-appointment-content">
          <div style="display: flex; background-color: white; border-radius: var(--border-radius); padding: var(--margin-size); height: fit-content;" data-cy="scheduler-appointment-details">
            <div style="flex: 1; display: flex;" data-cy="scheduler-appointment-patient-info">
              <div style="flex-basis: 150px;" data-cy="scheduler-appointment-patient-image-container">
                <img [src]="getPatientPicture(d)" style="border-radius: var(--border-radius); margin-right: 2px; max-width: 100%; max-height: 100%;" data-cy="scheduler-appointment-patient-image" />
              </div>
              <div style="flex-basis: 8px;"></div>
              <div style="flex: 1; display: flex; flex-direction: column;">
                <div style="flex-basis: fit-content; display: flex;" data-cy="scheduler-appointment-info-section">
                  <div style="flex-basis: 200px;" data-cy="scheduler-appointment-procedure-section">
                    <div style="font-size: 12px;" data-cy="scheduler-appointment-procedure-label">This Appointment</div>
                    <div style="font-weight: 500;" data-cy="scheduler-appointment-procedure-value">{{getProcedureType(d.ProcedureType)}}</div>
                  </div>
                  <div style="flex-basis: 200px;" data-cy="scheduler-appointment-referral-section">
                    <div style="font-size: 12px;" data-cy="scheduler-appointment-referral-label">Referred By:</div>
                    <div style="font-weight: 500;" data-cy="scheduler-appointment-referral-value">{{d.ReferredByDoctorName}}</div>
                  </div>
                </div>
                <div style="flex: 1; display: flex; flex-direction: column;" data-cy="scheduler-appointment-alerts-section">
                  <div style="flex-basis: fit-content;" data-cy="scheduler-appointment-alerts-label">Alerts</div>
                  <div style="width: 100%; flex: 1; background-color: #f1f1f1; border-radius: var(--border-radius); display: flex; padding: 3px;" data-cy="scheduler-appointment-alerts-container">
                    <div style="flex: 1; font-size: 12px;" data-cy="scheduler-appointment-patient-flags-section">
                      <div style="font-weight: 500;" data-cy="scheduler-appointment-patient-flags-label">Patient Flags</div>
                      <div style="display: flex; flex-direction: column; flex-wrap: wrap; line-height: 0.9;" data-cy="scheduler-appointment-patient-flags-list">
                        <div *ngFor="let flag of d.PatientFlags" data-cy="scheduler-appointment-patient-flag-item">{{getPatientFlag(flag)}}</div>
                      </div>
                    </div>
                    <div style="flex: 1; font-size: 12px;" data-cy="scheduler-appointment-flags-section">
                      <div style="font-weight: 500;" data-cy="scheduler-appointment-flags-label">Appointment Flags</div>
                      <div style="display: flex; flex-direction: column; flex-wrap: wrap; line-height: 0.9;" data-cy="scheduler-appointment-flags-list">
                        <div *ngFor="let flag of d.AppointmentFlags" data-cy="scheduler-appointment-flag-item">{{getAppointmentFlag(flag)}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="flex-basis: 16px;"></div>
            <div style="flex: 1; display: flex; flex-direction: column;" data-cy="scheduler-appointment-images-section">
              <div style="font-size: 12px; flex-basis: fit-content;" data-cy="scheduler-appointment-images-label">Images:</div>
              <div style="flex: 1; display: flex; width: 100%; overflow-x: auto;" data-cy="scheduler-appointment-images-container">
                <div *ngFor="let id of d.DocumentIds" style="height: 130px; margin-right: 6px;" data-cy="scheduler-appointment-image-item"><img style="height: 100%;" [src]="getDocument(d, id)" data-cy="scheduler-appointment-image" /></div>
              </div>
            </div>
          </div>
        </app-tdo-accordion-item-content>
      </app-tdo-accordion-item>
    </app-tdo-accordion>
  </div>
</div>
